@if (appType === 'PROD-PAGE' || appType === 'BMTV') {
  <div class="social-icons">
    @for (i of getIcons(); track i) {
      <a class="social-icon theme-contacts__socIcons" href="{{ i.url }}" target="_blank">
        <span class="icon btv-icon-{{ i.icon }}"></span>
      </a>
    }
  </div>
}
